import { FormMonthSelect } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import {
  useFormItem,
  useNextDisabled,
  useNextLoading,
  useOnNextClick,
} from '@/providers'
import { currentYear, isValidDate } from '@/utils'
import { isNil } from 'ramda'
import { useSaveAssessmentStep } from '../helpers'
import { JSX } from 'react'

export const ConstructionDateStep = (): JSX.Element => {
  const { value } = useFormItem('constructionDate')

  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.constructionDate,
  )

  useOnNextClick(save)

  useNextDisabled(() => !isValidDate(new Date(value)) || isNil(value), [value])

  useNextLoading(() => isLoading, [isLoading])

  return (
    <FormMonthSelect
      initialValue={new Date(currentYear(), 0).getTime()}
      maxDate={new Date(currentYear(), 11, 31, 12)}
      name="constructionDate"
      label=""
      info=""
      helperText=""
      ignoreErrorKeys={[]}
      showErrorHelperText={true}
      shouldRenderInModal={false}
    />
  )
}
